import {Component} from "react";
import * as shortid from "shortid";
import React from "react";
import {SubjectItem} from './SubjectItem.component';

/**
 * React component Subject - Level selector
 */
export class SubjectLevelRowComponent extends Component {

    /**
     * Sets initial state
     * @param props
     */
    constructor(props) {
        super(props);
        const list = [];
        list.push(shortid.generate()); // populate with 1 item

        this.state = {list: list};
    }

    /**
     * Add new subject-level row
     */
    onAddItem(){
        this.setState({
            list : [...this.state.list, shortid.generate()]
        });
    }

    /**
     * Remove last subject from list
     */
    onDeleteItem() {
        if (this.state.list.length > 1) {
            let list = this.state.list.slice();
            list.pop();

            this.setState({
                list : list
            });
        }
    }

    render() {

        const list = this.state.list.map((key) => {
            return (
                <SubjectItem key={key}
                    courses={this.props.courses}
                    levels={this.props.levels}/>
            );
        });

        return (
            <div>
                {list}
                <span id="add-row-button"
                      className="ui-btn ui-btn--small ui-btn--secondary float-right"
                      onClick={() => this.onAddItem()}>
                    Voeg vak toe
                </span>
                {list.length > 1 &&
                <span id="remove-row-button"
                      className="ui-btn ui-btn--small ui-btn--boring float-right"
                      onClick={() => this.onDeleteItem()}>
                    Verwijder laatste
                </span>
                }
            </div>
        );
    }
}
